import { render, staticRenderFns } from "./carousel-form.vue?vue&type=template&id=904d6dc8&"
import script from "./carousel-form.vue?vue&type=script&lang=js&"
export * from "./carousel-form.vue?vue&type=script&lang=js&"
import style0 from "./carousel-form.vue?vue&type=style&index=0&id=904d6dc8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports